import { render, staticRenderFns } from "./createSocio.vue?vue&type=template&id=2454829e&scoped=true&"
import script from "./createSocio.vue?vue&type=script&lang=js&"
export * from "./createSocio.vue?vue&type=script&lang=js&"
import style0 from "./createSocio.vue?vue&type=style&index=0&id=2454829e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454829e",
  null
  
)

export default component.exports